function getCheer() {
    const date = new Date();
    const proosten = [
        'Yamas!',
        'Proost!',
        "Sant\xe9!",
        'Cheers!',
        'Prosit!',
        "Sk\xf8ll!",
        "Eg\xe9szs\xe9gedre!"
    ];
    return ` ${proosten[date.getDay()]}`;
}
document.addEventListener('DOMContentLoaded', ()=>{
    const cheerElement = document.getElementById("cheer-of-the-day");
    const cheer = getCheer();
    cheerElement.textContent = cheer;
    const yearElement = document.getElementById("year");
    const year = new Date().getFullYear();
    yearElement.textContent = year;
});

//# sourceMappingURL=app.8099a580.js.map
